import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["file", "gatsbyFile", "description", "altText"];
var _contentTypeToCompone;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import _get from 'lodash/get';
import _head from 'lodash/head';
import { TILE_CONTENT_GROUP_CLASS_NAME, TILE_CONTENT_TYPE, TILE_CONTENT_TYPE_MARKDOWN } from './DynamicTile.constants';
import { Content, Markdown, Interaction } from './components';
import { createComponent } from '../../../../../foundation/services/components';
export function isElementContent(element) {
  var content = element.content,
    contentType = element.contentType;
  return !!content && contentType !== TILE_CONTENT_TYPE_MARKDOWN;
}
export function isElementMarkdown(element) {
  var content = element.content,
    contentType = element.contentType;
  return !!content && contentType === TILE_CONTENT_TYPE_MARKDOWN;
}
export function isElementInteraction(element) {
  var displayType = element.displayType,
    behaviorType = element.behaviorType;
  return Boolean(displayType) && Boolean(behaviorType);
}
export var elementToComponentMap = [{
  test: isElementContent,
  type: TILE_CONTENT_TYPE.CONTENT
}, {
  test: isElementMarkdown,
  type: TILE_CONTENT_TYPE.MARKDOWN
}, {
  test: isElementInteraction,
  type: TILE_CONTENT_TYPE.INTERACTION
}];
export var contentTypeToComponentMap = (_contentTypeToCompone = {}, _defineProperty(_contentTypeToCompone, TILE_CONTENT_TYPE.CONTENT, Content), _defineProperty(_contentTypeToCompone, TILE_CONTENT_TYPE.MARKDOWN, Markdown), _defineProperty(_contentTypeToCompone, TILE_CONTENT_TYPE.INTERACTION, Interaction), _contentTypeToCompone);
function getElementType(element) {
  var elementToComponent = elementToComponentMap.filter(function (_ref) {
    var checkElementType = _ref.test;
    return checkElementType(element);
  });
  return _get(elementToComponent, '[0].type', null);
}
export function createComponentsFromGroupedElements(elements) {
  return elements.map(function (elementGroup) {
    var elementKey = elementGroup.reduce(function (key, _ref2) {
      var _id = _ref2._id;
      return "".concat(key, "-").concat(_id);
    }, 'tile-element');
    return /*#__PURE__*/React.createElement("div", {
      key: elementKey,
      className: TILE_CONTENT_GROUP_CLASS_NAME
    }, elementGroup.map(function (element) {
      return elementToComponentMap.reduce(function (accumulatedComponent, _ref3) {
        var checkElementType = _ref3.test,
          componentType = _ref3.type;
        if (checkElementType(element)) {
          var pk = element._id;
          var component = contentTypeToComponentMap[componentType];
          var componentKey = "".concat(componentType, "-").concat(pk);
          var componentProps = {
            key: componentKey,
            element: element
          };
          return createComponent(component, componentProps);
        }
        return accumulatedComponent;
      }, null);
    }));
  });
}
export function sortElementsByOrder(elements) {
  return (elements || []).sort(function (elementA, elementB) {
    var elementAType = getElementType(elementA);
    var elementBType = getElementType(elementB);
    if (elementAType === elementBType) {
      return elementA.order - elementB.order;
    }
    if (elementAType === TILE_CONTENT_TYPE.INTERACTION) {
      return 1;
    }
    if (elementBType === TILE_CONTENT_TYPE.INTERACTION) {
      return -1;
    }
    return elementA.order - elementB.order;
  });
}
export function groupElementsByTypeInOrder(elements) {
  return (elements || []).reduce(function (groupedElements, element) {
    var elementContent = element.content;
    var isContentElement = !!elementContent;
    var previousGroup = groupedElements[groupedElements.length - 1] || [];
    var previousElement = previousGroup[0] || {};
    var previousElementContent = previousElement.content;
    var hasElementChanged = isContentElement !== !!previousElementContent;
    if (groupedElements.length === 0 || hasElementChanged) {
      groupedElements.push([]);
    }
    groupedElements[groupedElements.length - 1].push(element);
    return groupedElements;
  }, []);
}
export function getImage(images) {
  var firstImage = _head(images);
  if (!firstImage) {
    return {};
  }
  var file = firstImage.file,
    gatsbyFile = firstImage.gatsbyFile,
    description = firstImage.description,
    altText = firstImage.altText,
    restFile = _objectWithoutProperties(firstImage, _excluded);
  var baseImage = _objectSpread(_objectSpread({}, restFile), {}, {
    altText: altText || description
  });
  if (gatsbyFile) {
    return _objectSpread(_objectSpread({}, baseImage), {}, {
      src: gatsbyFile.childImageSharp
    });
  }
  return _objectSpread(_objectSpread({}, baseImage), {}, {
    src: file
  });
}